// extracted by mini-css-extract-plugin
export var label = "index-module--label--2PH_g";
export var meetingPointsContainer = "index-module--meetingPointsContainer--hVgf5";